module.exports = __webpack_public_path__ + "img/study_club.2e40bb9c.png";